(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["layali-plinko-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-layali-reward][data-flow-version="2"]');
    if (!root || root.dataset.readyV2 === 'true') return;
    root.dataset.readyV2 = 'true';

    const dialog = root.querySelector('[data-reward-dialog]');
    const stages = [...root.querySelectorAll('[data-reward-stage]')];
    const board = root.querySelector('[data-reward-board]');
    const ball = root.querySelector('[data-reward-ball]');
    const pegs = root.querySelector('[data-reward-pegs]');
    const claimForm = root.querySelector('#LayaliRewardClaimForm');
    const claimButton = root.querySelector('[data-reward-claim]');
    const emailInput = root.querySelector('#LayaliRewardEmail');
    const phoneForm = root.querySelector('#LayaliRewardPhoneForm');
    const phoneButton = root.querySelector('[data-reward-phone-submit]');
    const phoneInput = root.querySelector('#LayaliRewardPhone');
    const phoneEmail = root.querySelector('[data-reward-phone-email]');
    const phoneReward = root.querySelector('[data-reward-phone-reward]');
    const phoneBody = root.querySelector('[data-reward-phone-body]');
    const sink = root.querySelector('[data-reward-sink]');
    const rewardCode = root.querySelector('[data-reward-code]');
    const rewardTitle = root.querySelector('[data-reward-title]');
    const rewardShop = root.querySelector('[data-reward-shop]');
    const rewardValue = root.querySelector('[data-reward-value]');
    const awardTitle = root.querySelector('[data-reward-award-title]');
    const doubleStake = root.querySelector('[data-double-stake]');
    const doubleTitle = root.querySelector('[data-double-title]');
    const doubleCopy = root.querySelector('[data-double-copy]');
    const doubleCode = root.querySelector('[data-double-code]');
    const doubleCodeRow = root.querySelector('[data-double-code-row]');
    const doubleShipping = root.querySelector('[data-double-shipping]');
    const doubleMark = root.querySelector('[data-double-mark]');
    const doubleShop = root.querySelector('[data-double-shop]');
    const params = new URLSearchParams(window.location.search);
    const force = params.get('layali_reward_preview') === '1';
    const reset = params.get('layali_reward_reset') === '1';
    const storageKey = 'layaliRewardCustomerV2';
    const sessionKey = 'layaliRewardSeenV2';
    let customer = {};
    let currentReward = null;
    let pendingSubmission = '';
    let claimArmed = false;
    let phoneArmed = false;

    if (reset) {
      localStorage.removeItem(storageKey);
      sessionStorage.removeItem(sessionKey);
    }

    try {
      customer = JSON.parse(localStorage.getItem(storageKey) || '{}');
    } catch {
      localStorage.removeItem(storageKey);
      customer = {};
    }

    claimForm.target = 'LayaliRewardSink';
    phoneForm.target = 'LayaliRewardSink';

    const saveCustomer = () => localStorage.setItem(storageKey, JSON.stringify(customer));
    const random = () => crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296;

    const setStage = (name) => {
      stages.forEach((stage) => stage.classList.toggle('is-active', stage.dataset.rewardStage === name));
    };

    const applyCodeUrl = (code) => `${root.dataset.discountRoot}${code}?redirect=${root.dataset.discountRedirect}`;

    const setCode = (element, code) => {
      element.textContent = code || '';
    };

    const copyCode = async (element, button) => {
      if (!element.textContent) return;
      try {
        await navigator.clipboard.writeText(element.textContent);
      } catch {
        const range = document.createRange();
        range.selectNodeContents(element);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
      const original = button.textContent;
      button.textContent = root.dataset.copiedLabel;
      setTimeout(() => { button.textContent = original; }, 1600);
    };

    const selectReward = () => {
      const value = random();
      if (value < 0.90) return { amount: 5, code: '7E104FBA59FBA8A1', slots: [0, 4] };
      if (value < 0.99) return { amount: 7, code: '48776BB81480BFB6', slots: [1, 3] };
      return { amount: 10, code: '3228AB56A35839DB', slots: [2] };
    };

    const buildPegs = () => {
      pegs.replaceChildren();
      for (let row = 0; row < 8; row += 1) {
        const count = row % 2 === 0 ? 7 : 6;
        for (let column = 0; column < count; column += 1) {
          const peg = document.createElement('i');
          peg.className = 'layali-reward__peg';
          const x = ((column + 1) / (count + 1)) * 100;
          const y = 13 + row * 9.2;
          peg.style.left = `calc(${x}% - 2.5px)`;
          peg.style.top = `calc(${y}% - 2.5px)`;
          pegs.append(peg);
        }
      }
    };

    const dropBall = async (reward) => {
      buildPegs();
      ball.getAnimations().forEach((animation) => animation.cancel());
      const width = board.clientWidth;
      const slot = reward.slots[Math.floor(random() * reward.slots.length)];
      const endX = ((slot + 0.5) / 5 - 0.5) * width;
      const keyframes = [{ transform: 'translate3d(0, 0, 0)', opacity: 1 }];

      for (let row = 1; row <= 8; row += 1) {
        const progress = row / 8;
        const drift = endX * Math.pow(progress, 1.45);
        const bounce = (row % 2 === 0 ? -1 : 1) * (12 + random() * 16) * (1 - progress * 0.5);
        keyframes.push({
          transform: `translate3d(${drift + bounce}px, ${progress * 224}px, 0)`,
          opacity: 1,
          offset: progress * 0.88
        });
      }

      keyframes.push({ transform: `translate3d(${endX}px, 252px, 0)`, opacity: 1, offset: 1 });
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const animation = ball.animate(keyframes, {
        duration: reduced ? 600 : 2550,
        easing: 'cubic-bezier(0.3, 0.02, 0.24, 1)',
        fill: 'forwards'
      });
      await animation.finished;
    };

    const showClaim = () => {
      rewardValue.textContent = `£${currentReward.amount}`;
      awardTitle.textContent = root.dataset.claimTemplate.replace('__AMOUNT__', currentReward.amount);
      setStage('claim');
      emailInput.focus();
    };

    const showResult = (returning = false) => {
      const reward = currentReward || { amount: customer.amount, code: customer.code };
      if (!reward.amount || !reward.code) {
        setStage('play');
        return;
      }
      currentReward = reward;
      setCode(rewardCode, reward.code);
      rewardTitle.textContent = (returning ? root.dataset.returningTemplate : root.dataset.resultTemplate).replace('__AMOUNT__', reward.amount);
      rewardShop.href = applyCodeUrl(reward.code);
      setStage('result');
    };

    const renderDoubleResult = () => {
      const won = customer.doubleResult === 'win';
      doubleMark.textContent = won ? '✓' : '—';
      doubleTitle.textContent = won
        ? root.dataset.doubleWinTitle
        : root.dataset.doubleLossTitle;
      doubleCopy.textContent = won ? root.dataset.doubleWinCopy : root.dataset.doubleLossCopy;
      doubleCodeRow.hidden = !won;
      doubleShipping.hidden = !won;
      if (won) {
        setCode(doubleCode, customer.finalCode);
        doubleShop.href = applyCodeUrl(customer.finalCode);
      } else {
        setCode(doubleCode, '');
        doubleShop.href = root.dataset.shopUrl;
      }
      setStage('double-result');
    };

    const finishClaim = () => {
      if (pendingSubmission !== 'claim' || !currentReward) return;
      pendingSubmission = '';
      claimArmed = false;
      claimButton.disabled = false;
      customer.email = emailInput.value.trim().toLowerCase();
      customer.amount = currentReward.amount;
      customer.code = currentReward.code;
      customer.claimedAt = Date.now();
      delete customer.doubleResult;
      delete customer.finalAmount;
      delete customer.finalCode;
      saveCustomer();
      showResult(false);
    };

    const finishPhone = async () => {
      if (pendingSubmission !== 'phone' || !currentReward) return;
      pendingSubmission = '';
      phoneArmed = false;
      phoneButton.disabled = true;
      const consentInput = phoneForm.querySelector('[name="contact[sms_consent]"]');
      const smsConsent = consentInput?.checked === true;
      try {
        const response = await fetch('/apps/layali-rewards', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: customer.email, phone: phoneInput.value.trim(), smsConsent })
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result?.ok) {
          phoneInput.setCustomValidity(result?.message || 'We could not save your phone number. Please try again.');
          pendingSubmission = '';
          phoneButton.disabled = false;
          phoneInput.reportValidity();
          return;
        }
        phoneInput.setCustomValidity('');
      } catch {
        phoneInput.setCustomValidity('We could not save your phone number. Please try again.');
        pendingSubmission = '';
        phoneButton.disabled = false;
        phoneInput.reportValidity();
        return;
      }
      customer.phone = phoneInput.value.trim();
      saveCustomer();
      setStage('double');
      await new Promise((resolve) => setTimeout(resolve, 2100));
      const won = random() < 0.5;
      customer.doubleResult = won ? 'win' : 'loss';
      if (won) {
        customer.finalCode = root.dataset.shippingCode;
      } else {
        customer.finalCode = '';
      }
      customer.doubledAt = Date.now();
      saveCustomer();
      renderDoubleResult();
    };

    const open = () => {
      if (dialog.open) return;
      root.hidden = false;
      sessionStorage.setItem(sessionKey, '1');
      if (customer.doubleResult) {
        renderDoubleResult();
      } else if (customer.email && customer.code) {
        currentReward = { amount: Number(customer.amount), code: customer.code };
        showResult(true);
      } else {
        setStage('play');
      }
      dialog.showModal();
    };

    const close = () => {
      sessionStorage.setItem(sessionKey, '1');
      dialog.close();
      root.hidden = true;
    };

    root.querySelector('[data-reward-play]').addEventListener('click', async (event) => {
      if (!event.isTrusted) return;
      currentReward = selectReward();
      setStage('game');
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      await dropBall(currentReward);
      showClaim();
    });

    claimButton.addEventListener('click', (event) => {
      claimArmed = event.isTrusted;
    });

    claimForm.addEventListener('submit', (event) => {
      const approved = pendingSubmission === 'claim' || claimArmed && event.submitter === claimButton;
      if (!approved || !claimForm.reportValidity()) {
        event.preventDefault();
        return;
      }
      if (pendingSubmission === 'claim') return;
      claimButton.disabled = true;
      pendingSubmission = 'claim';
      event.preventDefault();
(async () => {
  const email = emailInput.value.trim().toLowerCase();
  const emailConsent = true;
  const emailError = claimForm.querySelector('[data-reward-email-error]');
  if (emailError) { emailError.hidden = true; emailError.textContent = ''; }
  try {
    const response = await fetch('/apps/layali-rewards', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ stage: 'email', email, emailConsent })
    });
    const result = await response.json().catch(() => null);
    if (!response.ok || !result?.ok) throw new Error(result?.message || 'We could not save your email subscription. Please try again.');
    customer.email = email;
    saveCustomer();
    finishClaim();
  } catch (error) {
    pendingSubmission = '';
    claimButton.disabled = false;
    if (emailError) { emailError.textContent = error.message || 'We could not save your email subscription. Please try again.'; emailError.hidden = false; }
  }
})();
    });

    root.querySelector('[data-reward-copy]').addEventListener('click', () => copyCode(rewardCode, root.querySelector('[data-reward-copy]')));

    root.querySelector('[data-reward-double]').addEventListener('click', (event) => {
      if (!event.isTrusted) return;
      phoneEmail.value = customer.email || '';
      phoneInput.value = customer.phone || '';
      if (phoneReward) phoneReward.value = currentReward ? `£${currentReward.amount} reward` : '';
      if (phoneBody) {
        phoneBody.value = `Drop the Pearl phone capture | email: ${customer.email || ''} | reward: £${currentReward?.amount || ''} | SMS consent: yes`;
      }
      doubleStake.textContent = root.dataset.doubleStakeTemplate
        .replace('__AMOUNT__', currentReward.amount)
        .replace('__DOUBLED__', currentReward.amount * 2);
      setStage('phone');
      phoneInput.focus();
    });

    phoneButton.addEventListener('click', (event) => {
      phoneArmed = event.isTrusted;
    });

    phoneForm.addEventListener('submit', (event) => {
      phoneInput.setCustomValidity('');
  const approved = pendingSubmission === 'phone' || phoneArmed && event.submitter === phoneButton;
      if (!approved || !phoneForm.reportValidity()) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
  if (pendingSubmission === 'phone') return;
      phoneButton.disabled = true;
      pendingSubmission = 'phone';
  void finishPhone();
    });

    sink.addEventListener('load', () => {
      if (pendingSubmission === 'claim') finishClaim();
      if (pendingSubmission === 'phone') finishPhone();
    });

    root.querySelector('[data-double-copy-button]').addEventListener('click', () => copyCode(doubleCode, root.querySelector('[data-double-copy-button]')));
    root.querySelector('[data-reward-close]').addEventListener('click', close);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('click', (event) => {
      const box = dialog.getBoundingClientRect();
      const outside = event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
      if (outside) close();
    });

    if (force || sessionStorage.getItem(sessionKey) !== '1') {
      let opened = false;
      const trigger = () => {
        if (opened) return;
        opened = true;
        open();
      };
      const onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable >= 0.35) {
          window.removeEventListener('scroll', onScroll);
          trigger();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      setTimeout(trigger, force ? 350 : 7000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
